/**
 * Image Hotspots Block - Interactivity API View Script
 *
 * Handles tooltip toggle, close, and click-outside for hotspot markers.
 * Each block instance has its own `openId` in root context (not store state),
 * so multiple blocks on the same page are independent.
 *
 * @package BrandyBlocks
 */

import { store, getContext, getElement } from '@wordpress/interactivity';

store( 'brandy/image-hotspots', {
	state: {
		/**
		 * True when this hotspot's tooltip is open.
		 * getContext() returns merged context: { openId, hotspotId }.
		 *
		 * @return {boolean}
		 */
		get isOpen() {
			const ctx = getContext();
			return ctx.openId !== '' && ctx.openId === ctx.hotspotId;
		},
	},

	actions: {
		/**
		 * Toggle the tooltip for the clicked hotspot.
		 * Opens if closed; closes if already open.
		 * Bound via data-wp-on--click on the marker button.
		 */
		toggle() {
			const ctx = getContext();
			ctx.openId = ctx.openId === ctx.hotspotId ? '' : ctx.hotspotId;
		},

		/**
		 * Close any open tooltip.
		 * Bound via data-wp-on-document--click on the root wrapper.
		 * Only closes when the click is outside all hotspot wrappers.
		 *
		 * @param {MouseEvent} event
		 */
		closeOnOutside( event ) {
			if ( event.target.closest( '.brandy-hotspot-wrap' ) ) {
				return;
			}
			const ctx = getContext();
			ctx.openId = '';
		},
	},
} );
